module.exports = function() {
  return new Worker(__webpack_public_path__ + "9a9d5d620a012e376e09.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
// module id = 2865
// module chunks = 1